import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import type { CreateProgramaInput } from "@/lib/validaciones/createProgramaSchema";
import { toast } from "sonner";

export const useRegisterPrograma = (options?: { queryKey?: string[] }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateProgramaInput) => {
      const res = await axiosInstance.post("/programas", data);
      return res.data;
    },
    onSuccess: () => {
      if (options?.queryKey) {
        queryClient.invalidateQueries({ queryKey: options.queryKey });
      } else {
        queryClient.invalidateQueries({ queryKey: ["programas"] });
      }
      toast.success("Programa creado exitosamente");
    },
    onError: () => {
      toast.error("Error al crear el programa");
    },
  });
};
